import { render } from "./documentview.vue?vue&type=template&id=a6cc54c0"
import script from "./documentview.js?vue&type=script&lang=js"
export * from "./documentview.js?vue&type=script&lang=js"

import "./documentview.vue?vue&type=style&index=0&id=a6cc54c0&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__